/* eslint-disable prettier/prettier */
import { SelectItem } from 'primeng/api';
import { EnumTipoExentoCertificacionCpe } from '../../../_importacion/solicitudes/types/enum';

export class PagingResultsViewModel {
    public TotalCount: number;

    public PageCount: number;

    public PageSize: number;
}

export class FilterSearchingBaseViewModel {
    public PageNumber: number;
    public Asc: number;
    public OrderBy = '';
}

//#region Enumerados

export enum TcPerfilUsuarioEnum {
    Solicitante = 1,
    Inspector = 2,
    Administrador = 3,
    Coordinador = 4,
    Magrama = 5,
    OperadorCampania = 6,
    Laboratorio = 7,
    EntidadAuditora = 9,
    ComunidadAutonoma = 10,
    Consultas = 11,
    Grabador = 12,
    AgenteControl = 16,
}

export enum EnumIdsTcPais {
    ID_ESPANA = 60,
    ID_RUSIA = 156,
    ID_BIELORRUSIA = 26,
    ID_KAZAKHSTAN = 99,
    ID_HOLANDA = 131,
    ID_PORTUGAL = 1,
    ID_EEUU = 197,
    ID_CHINA = 41,
    ID_ARGENTINA = 8,
    ID_CHILE = 40,
    ID_SUDAFRICA = 154,
    ID_BRASIL = 29,
    ID_JAPON = 98,
    ID_COREA_SUR = 102,
    ID_EGIPTO = 57,
    ID_IRAN = 87,
    ID_COMUNIDAD_EUROPEA = 256,
}

export enum EnumIdsTcProvincia {
    ID_TENERIFE = 38,
    ID_LAS_PALMAS = 35,
    ID_CEUTA = 51,
    ID_MELILLA = 52,
}

export enum EnumIdsTcIdioma {
    ID_ESPANOL = 1,
    ID_INGLES = 2,
    ID_CHINO = 3,
}

export enum EnumSiNoTodos {
    NO = 0,
    SI = 1,
    TODOS = 2,
}

export enum EnumSiNo {
    NO = 0,
    SI = 1,
}

export enum RequestService {
    TRACES = 0,
    ADUANAS = 1,
}

export enum TcTipoModuloEnum {
    Importacion = 1,
    Exportacion = 2,
    Campanias = 3,
    CexvegComunes = 4,
    Atestaciones = 5,
    Cpe = 6,
    Pv = 7,
}

//#endregion

export class Tc {
    constructor() {
        this.Id = 0;
        this.Descripcion = '';
    }
    public Id: number;
    public Descripcion: string;
}

export class TcVm {
    constructor() {
        this.Id = 0;
        this.Descripcion = '';
        this.Fecha = null;
    }
    public Id: number;
    public Descripcion: string;
    public Fecha: Date|null;
}

export class TcAnno {
    constructor() {  
        this.Anno = '';
    }
    public Anno: string;
}

export class TcNumeroSemana {
    constructor() {
        this.Anno = '';
        this.Descripcion = '';
    }
    public Anno: string;
    public Descripcion: string;
}

export class TcExpanded {
    constructor() {
        this.Id = 0;
        this.Descripcion = '';
        this.Codigo = '';
    }
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
}

export class GenericPostRequest {
    public Value: string;
}

//https://stackoverflow.com/questions/41467801/how-to-create-an-application-specific-config-file-for-typescript

export class Config {
    IdPaisEspania: number;
}

export class CustomError extends Error {
    key: string;
    field: string;
    value: boolean;

    constructor() {
        super();

        Object.setPrototypeOf(this, CustomError.prototype);
    }
}
export class LoggedUserViewModel {
    constructor() {}

    public getAction(codigo: string): ActionProfile;
    public getAction(codigo: string, idEstado: number): ActionProfile;
    public getAction(codigo: string, idEstado: number, idTipoSolicitud: number): ActionProfile;
    public getAction(codigo: string, idEstado: number, idTipoSolicitud: number, idSubtipo: number): ActionProfile;
    public getAction(codigo: string, idEstado?: number, idTipoSolicitud?: number, idSubTipo?: number): ActionProfile;
    public getAction(codigo: string, idEstado?: number, idTipoSolicitud?: number, idSubTipo?: number): ActionProfile {
        let accion: AccionViewModel = this.AccionCollection.filter(s => s.Codigo == codigo)[0];

        if (!accion) {
            return new ActionProfile(false, false);
        }

        if (this.TwUsuarioCa != null) {
            //Tenemos que ver por módulos
            //EXPORTACION: Exportación + Atestaciones + CPE
            if ((accion.IdModulo == TcTipoModuloEnum.Exportacion
                || accion.IdModulo == TcTipoModuloEnum.Atestaciones
                || accion.IdModulo == TcTipoModuloEnum.Cpe)
                && !this.TwUsuarioCa.AutorizadoCertificacionEx) {
                return new ActionProfile(false, false);
            }
            //CAMPAÑAS: Campañas específicas + Programa de verificación
            else if ((accion.IdModulo == TcTipoModuloEnum.Campanias
                || accion.IdModulo == TcTipoModuloEnum.Pv)
                && !this.TwUsuarioCa.AutorizadoCampanias) {
                return new ActionProfile(false, false);
            }
        }
        //Inspectores por modulos
        if (this.TwUsuarioInspector != null) {
            //IMPORTACIÓN
            if (accion.IdModulo == TcTipoModuloEnum.Importacion
                && !this.TwUsuarioInspector.AutorizadoImportacion) {
                return new ActionProfile(false, false);

            }
            //EXPORTACION: Exportación + Atestaciones + CPE
            else if ((accion.IdModulo == TcTipoModuloEnum.Exportacion
                || accion.IdModulo == TcTipoModuloEnum.Atestaciones
                || accion.IdModulo == TcTipoModuloEnum.Cpe)
                && !this.TwUsuarioInspector.AutorizadoExportacion) {
                return new ActionProfile(false, false);
            }
        }

        let accionesPerfil: AccionPerfilViewModel[] = accion.AccionPerfilCollection;

        if (accion.AnyEstado) {
            if (idEstado && accionesPerfil.some(s => s.IdEstado == idEstado)) {
                accionesPerfil = accionesPerfil.filter(s => s.IdEstado == idEstado);
            } else {
                accionesPerfil = accionesPerfil.filter(s => s.IdEstado == null);
            }
        }

        if (accion.AnyTipoSolicitud) {
            if (idTipoSolicitud && accionesPerfil.some(s => s.IdTipoSolicitud == idTipoSolicitud)) {
                accionesPerfil = accionesPerfil.filter(s => s.IdTipoSolicitud == idTipoSolicitud);
            } else {
                accionesPerfil = accionesPerfil.filter(s => s.IdTipoSolicitud == null);
            }
        }

        if (accion.AnySubtipoSolicitud) {
            if (idSubTipo && accionesPerfil.some(s => s.IdSubTipoSolicitud == idSubTipo)) {
                accionesPerfil = accionesPerfil.filter(s => s.IdSubTipoSolicitud == idSubTipo);
            } else {
                accionesPerfil = accionesPerfil.filter(s => s.IdSubTipoSolicitud == null);
            }
        }

        return new ActionProfile(accionesPerfil.length > 0, accionesPerfil.length > 0 && accionesPerfil.some(s => s.Edicion));
    }

    public hasProfile(perfilUsuarioEnum: TcPerfilUsuarioEnum): boolean {
        return this.TUsuarioPerfilCollection.some(s => s.IdPerfil == perfilUsuarioEnum.valueOf());
    }

    public Nombre: string;
    public Apellidos: string;
    public Email: string;
    public Id: number;
    public NIF: string;
    public TokenResponse: TokenResponseViewModel;
    public AccionCollection: AccionViewModel[];
    public TUsuarioPerfilCollection: TUsuarioPerfilViewModel[];
    public TwUsuarioCa: TwUsuarioCaViewModel;
    public TwUsuarioInspector: TwUsuarioInspectorViewModel;
    public TwRegTecnicoEntidadAuditora: TwRegTecnicoEntidadAuditoraViewModel;
    public XmlSignedId: string; // Indicará si el usuario se ha autenticado vía Cl@ve o no
}
export class AccionPerfilViewModel {
    public Id: number;
    public IdAccion: number;
    public IdPerfil: number;
    public IdEstado: number | null;
    public IdTipoSolicitud: number | null;
    public IdSubTipoSolicitud: number | null;
    public Edicion: boolean;
}
export class AccionViewModel {
    public Id: number;
    public IdModulo: number;
    public Descripcion: string;
    public Codigo: string;
    public AnyEstado: boolean;
    public AnyTipoSolicitud: boolean;
    public AnySubtipoSolicitud: boolean;
    public AccionPerfilCollection: AccionPerfilViewModel[];
}
export class TwUsuarioCaViewModel {
    public IdUsuario: number;
    public IdCa: number;
    public AutorizadoCertificacionEx: boolean;
    public AutorizadoCampanias: boolean;
    public Descripcion: string;
}
export class TwUsuarioInspectorViewModel {
    public IdUsuario: number;
    public AutorizadoImportacion: boolean;
    public AutorizadoExportacion: boolean;
}
export class TwRegTecnicoEntidadAuditoraViewModel {
    public IdUsuario: number;
    public IdRegEntidadAuditora: number;
}
export class TUsuarioPerfilViewModel {
    public Id: number;
    public IdUsuario: number;
    public IdPerfil: number;
    public Descripcion: string;
}
export class TokenResponseViewModel {
    public Token: string;
    public Expiration: number;
    public RefreshToken: string;
}
export class TokenRequestViewModel {
    public UserID: string;
    public Password: string;
    public GrantType: string;
    public CASTicket: string;
    public RefreshToken: string;
    public XmlSignedId: string;
}

export class ActionProfile {
    constructor(visible: boolean, editable: boolean) {
        this.Visible = visible;
        this.Editable = editable;
    }

    public Visible: boolean;
    public Editable: boolean;
}

export class TTasaViewModel {
    public Id: number;
    public IdSolicitud: number;
    public TotalTasas: number;
    public NumeroLiquidacion: string;
    public FechaLiquidacion: Date;
}

export class TTasaExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public TotalTasas: number;
    public NumeroLiquidacion: string;
    public FechaLiquidacion: Date;
}

export class TwTcEppoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TwTcEppoViewModel[];
}

export class TwTcEppoViewModel {
    public Id: number;
    public CodigoEppo = '';
    public InvasivaNoPermitida = false;
}

export class TcPaisUsaCodigoPostal {
    constructor() {
        this.Id = 0;
        this.Descripcion = '';
        this.UsaCodigoPostal = false;
    }
    public Id: number;
    public Descripcion: string;
    public UsaCodigoPostal: boolean;
    public EsUnionEuropea: boolean;
}

//común a Motivos y Medidas, igual que Tc pero añadiendo CodigoTraces
export class MotivoMedidaViewModel {
    constructor() {
        this.Id = 0;
        this.Descripcion = '';
        this.CodigoTraces = '';
        this.ReguladoUE = false;
    }
    public Id: number;
    public Descripcion: string;
    public CodigoTraces: string;
    public ReguladoUE: boolean;
}

//ESPECIES - Unificadas 24102019.

//WBotanicaViewModel sólo lo usa especieEppoPopup.component.ts
export class WBotanicaViewModel {
    public Id: number;
    public IdNombreCientifico: number;
    public IdNombreCientificoDescripcion: string;
    public IdForma: number;
    public CodigoEppo: string;
    public Favorito: string;
    public NombreComun: string;
}

//WBotanicaItemResultsViewModel no lo usa nadie, podría borrarse
export class WBotanicaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WBotanicaViewModel[];
}

export class WBotanicaExtendedViewModel {
    public IdNombreCientifico: number;
    public IdNombreCientificoDescripcion = '';
    public IdGrupoDescripcion = '';
    public IdCodigoEppo: number;
    public CodigoEppo = '';
    public Favorito: boolean;
    public Id: number;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public IdGrupo: number;
    public IdSubForma: number;
    public NombreComun = '';
    public Activo = false;
    public Habilitado = false;
    public HabilitadoImportacion = true;
    public HabilitadoExportacion = true;
    public HabilitadoChina = true;
    public EphytoReinoUnido: boolean;
    public AplicaDocumentacion: boolean;
}

export class WBotanicaExtendedItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WBotanicaExtendedViewModel[];
}

//ORGANISMOS NOCIVOS
export class WOrganismosNocivosExtendedItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WOrganismosNocivosExtendedViewModel[];
}

export class WOrganismosNocivosExtendedViewModel {
    public Id: number;
    public TipoExento: EnumTipoExentoCertificacionCpe;
    public DataType: '';
    public Code: '';
    public CodeId: number | null;
    public Preferred: boolean;
    public Status: boolean;
    public FullName: '';
    public RegulatedUe: boolean;
    public NoEspecie: boolean;
}

export class TwTcTipoOrganismoNocivoViewModel {
    public Codigo = '';
    public Descripcion = '';
}

export class AduanasResponseViewModel {
    public IsOK: boolean;
    public Codigo: string;
    public Descripcion: string;
}

export class ActionType {
    public IdEstadoSolicitud: number;
    public IdTipoSolicitud: number | null;
    public IdSubTipoSolicitud: number | null;
}

//UNLOCODE

export class MegaSizeLimitItem {
    public Component: string;
    public SizeLimit: number;
}
export class MegaSizeLimitViewModel {
    public Limits: MegaSizeLimitItem[];
}

export class WUnlocodeViewModel {
    public Id: number;
    public CodPais: string;
    public Descripcion: string;
    public CodLocation: string;
    public DescripcionLocation: string;
    public CodSubdivision: string;
    public DescripcionSubDivision: string;
}

export class WUnlocodeItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WUnlocodeViewModel[];
}

export const ListSiNoTodos: SelectItem[] = [
    { label: 'Sí', value: EnumSiNoTodos.SI },
    { label: 'NO', value: EnumSiNoTodos.NO },
    { label: 'TODOS', value: EnumSiNoTodos.TODOS },
];

export const ListSiNo: SelectItem[] = [
    { label: 'Sí', value: EnumSiNoTodos.SI },
    { label: 'NO', value: EnumSiNoTodos.NO },
];

export const enum AUTH_GRANT_TYPE_ENUM {
    CAS = 'cas_server',
    PASSWORD = 'password',
    REFRESH_TOKEN = 'refresh_token',
    REFRESH_ACLAVE = 'refresh_aclave_token',
}

export const MILISEGUNDOS_EN_MINUTO = 60000;
export const MILISEGUNDOS_ANTICIPACION_REFRESH = 20000; // 20 segundos
